import toast from 'react-hot-toast';
import { useCallback } from 'react';

interface ToastActionOptions {
  loading: string;
  success: string;
  error?: string;
}

export function useToastAction() {
  const run = useCallback(
    (actionFn: () => Promise<unknown>, messages: ToastActionOptions): void => {
      const toastId = toast.loading(messages.loading);
      actionFn().then(
        () => { toast.success(messages.success, { id: toastId }); },
        (err: unknown) => {
          const detail = (err as { response?: { data?: { detail?: string } } })
            ?.response?.data?.detail;
          toast.error(detail || messages.error || 'Something went wrong', {
            id: toastId,
          });
        },
      );
    },
    [],
  );
  return { run };
}
